import { Card } from "antd";
import { useAppSelector } from "../../../app/store";
import GrayEmailIco from "../../../assets/icons/GrayEmailIco";
import OfficeIcon from "../../../assets/icons/sidebar/OfficeIcon";
import OfficeIdIcon from "../../../assets/icons/sidebar/OfficeIdIcon";
import UploadProfileImage from "../../../components/Employees/edit/UploadProfileImage";

export default function UserInfo() {
  const { user } = useAppSelector((state) => state.auth);

  return (
    <>
      <Card>
        <div className="mb-4 flex justify-center">
          <UploadProfileImage />
        </div>

        <div>
          <h3 className="font-medium text-[#5E718D] text-center text-sm mb-3">
            {user?.data?.username} <br />({user?.data?.role})
          </h3>
        </div>

        <div className="flex items-center justify-start space-x-4 border-t border-[#AFBACA] pt-3 pb-3">
          <div>
            <OfficeIcon />
          </div>

          <div>
            <h6 className="text-sm text-[#5E718D] font-normal">Company Name</h6>
            <h3 className="text-base text-[#5E718D] font-medium">
              {user?.data?.company?.company_name}
            </h3>
          </div>
        </div>

        <div className="flex items-center justify-start space-x-4 border-t border-[#AFBACA] pt-3 pb-3">
          <div>
            <OfficeIdIcon />
          </div>

          <div>
            <h6 className="text-sm text-[#5E718D] font-normal">
              Company Address
            </h6>
            <h3 className="text-base text-[#5E718D] font-medium">
              {user?.data?.company?.location}
            </h3>
          </div>
        </div>

        {/* <div className="flex items-center justify-start space-x-4 border-t border-[#AFBACA] pt-3 pb-3">
          <div>
            <GrayMobileIcon />
          </div>

          <div>
            <h6 className="text-sm text-[#5E718D] font-normal">
              Mobile Number
            </h6>
            <h3 className="text-base text-[#5E718D] font-medium">
              +8801734456780
            </h3>
          </div>
        </div> */}

        <div className="flex items-center justify-start space-x-4 border-t border-[#AFBACA] pt-3">
          <div>
            <GrayEmailIco />
          </div>

          <div>
            <h6 className="text-sm text-[#5E718D] font-normal">
              Email Address
            </h6>
            <h3 className="text-base text-[#5E718D] font-medium">
              {user?.data?.email}
            </h3>
          </div>
        </div>
      </Card>
    </>
  );
}
